<h1 mat-dialog-title>{{data.selection.length}} {{translate.instant('MASSEDIT.MODIFY_DOCUMENTS')}}</h1>
<div mat-dialog-content>

  <mat-accordion class="me-headers-align" multi>
    <mat-expansion-panel [disabled]="pInfoDisabled">

      <mat-expansion-panel-header>
        <mat-panel-title>
          {{translate.instant('MASSEDIT.MODIFY_INFORMATION')}}
        </mat-panel-title>
        <mat-panel-description>
          {{translate.instant('MASSEDIT.TYPE_CONTRACTOR_DEADLINE')}}
          <img alt="edit" style="height:24px" src="../../assets/Nestas_toolbox_bewerken.png" />
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-grid-list cols="7" rowHeight="65px" gutterSize="0px">

        <mat-grid-tile [rowspan]="1" class="first" [colspan]="2">
          <label>{{translate.instant('DATA.TYPE')}}</label>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="1" class="second" [colspan]="5">
          <mat-form-field class="fill">
            <mat-label></mat-label>
            <input matInput name="type" type="text" [matAutocomplete]="typeAutocomplete"
              placeholder="{{translate.instant('DATA.TYPE')}}" class="full-width margin-right-md"
              [formControl]="fileTypeControl" [(ngModel)]="newFile.type">
            <mat-hint>{{translate.instant('NEW_FILE.HINT.TYPE')}}</mat-hint>
            <mat-autocomplete #typeAutocomplete="matAutocomplete">
              <mat-option *ngFor="let fileType of filteredFileTypes | async" [value]="fileType.value">
                {{ fileType.value }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </mat-grid-tile>


        <mat-grid-tile [rowspan]="1" class="first" [colspan]="2">
          <label>{{translate.instant('DATA.CONTRACTOR')}}</label>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="1" class="second" [colspan]="5">
          <div class="wrapper-select full-width margin-right-md">

            <mat-form-field class="fill">
              <mat-label></mat-label>
              <input matInput name="contractor" [hidden]= "contractorRO()"type="text" placeholder="{{translate.instant('DATA.CONTRACTOR')}}"
                [matAutocomplete]="contractorAutocomplete" class="full-width margin-right-md"
                [formControl]="contractorControl" [(ngModel)]="newFile.contractor">

              <mat-hint [hidden]= "contractorRO()" >{{translate.instant('MASSEDIT.HINT.CONTRACTOR')}}</mat-hint>

              <mat-autocomplete #contractorAutocomplete="matAutocomplete">
                <mat-option *ngFor="let c of filteredContractors | async" [value]="formatContractor(c)">
                  {{formatContractor(c)}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          </mat-grid-tile>

            <mat-grid-tile [rowspan]="1" class="first" [colspan]="2">
             
            </mat-grid-tile>
            <mat-grid-tile [rowspan]="1" class="second" [colspan]="5">
              <mat-checkbox class="removeNotifications" [(ngModel)]="toRemoveContractor"
              (click)="removeContractor()">
            </mat-checkbox>
            <span class="boxinfo">{{translate.instant('MASSEDIT.DEL_CONTRACTOR')}}</span>
          </mat-grid-tile>
         
        


        <mat-grid-tile [rowspan]="1" *ngIf="newFile.providedByContractor" class="first" [colspan]="2">
          <label>{{translate.instant('DATA.DEADLINE')}}</label>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="1" *ngIf="newFile.providedByContractor" [colspan]="5">

          <div class="wrapper-select full-width margin-right-md">
            <input matInput name="completion" type="date" [(ngModel)]="newFile.completion" placeholder=""
              class="full-width margin-right-md mat-input-style" [value]="newFile.completion" />
          </div>

        </mat-grid-tile>

        <ng-container *ngIf="newFile.providedByContractor && newFile.emailSent">
          <mat-grid-tile [rowspan]="1" *ngIf="newFile.providedByContractor" class="first" [colspan]="1">
          </mat-grid-tile>
          <mat-grid-tile [rowspan]="1" [colspan]="5">
            <div lass="alert-warning margin-bottom-sm margin-right-md">
              <i class="material-icons ic-warning">warning</i> {{translate.instant('NEW_FILE.SEND_NEW_MAIL')}}
            </div>
          </mat-grid-tile>
        </ng-container>

        <ng-container *ngIf="newFile.providedByContractor">
          <mat-grid-tile [rowspan]="1" [colspan]="7">
            <div class="alert-info margin-right-md">
              <i class="material-icons ic-info">info</i>&nbsp;{{translate.instant('MESSAGE.WARNING_SENDING_EMAIL')}}
            </div>
          </mat-grid-tile>
        </ng-container>

      </mat-grid-list>
    </mat-expansion-panel>

    <mat-expansion-panel [disabled]="pNotDisabled">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{translate.instant('MASSEDIT.NOTIFICATIONS')}}
        </mat-panel-title>
        <mat-panel-description>
          {{translate.instant('MASSEDIT.ADD_DEL_MOD')}}
          <mat-icon>date_range</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-grid-list cols="10" rowHeight="65px" gutterSize="15px">
        <ng-container *ngFor="let n of notifications; let index=index ">

          <mat-grid-tile [rowspan]="notrowspan" [colspan]="2">
            <label>{{translate.instant('DATA.NOTIFICATIONS')}} {{index+1}}:</label>
          </mat-grid-tile>

          <mat-grid-tile [rowspan]="notrowspan" [colspan]="3">
            <mat-form-field>
              <input matInput [(ngModel)]="n.topic" [ngModelOptions]="{standalone: true}" type="text"
                placeholder="{{translate.instant('DATA.TOPIC')}}" class="full-width margin-right-md">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [rowspan]="notrowspan" [colspan]="2">
            <mat-form-field>
              <input matInput [(ngModel)]="n.targetdate" [ngModelOptions]="{standalone: true}" type="date"
                placeholder="{{translate.instant('DATA.TARGET_DATE')}}"
                (change)="targetdateChangeEvent($event.target.value, index)" class="full-width margin-right-md">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [rowspan]="notrowspan" [colspan]="3">
            <select [(ngModel)]="n.frequency" class="frequency" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let f of frequencies" [value]="f">{{translate.instant('DATA.' + f)}}</option>
            </select>
          </mat-grid-tile>



          <!--<input matInput [(ngModel)]="n.frequency" [ngModelOptions]="{standalone: true}" type="text" placeholder="{{translate.instant('DATA.FREQUENCY')}}"
                   class="full-width margin-right-md">-->

        </ng-container>



        <mat-grid-tile *ngIf="!newFile.removeNotifications" [rowspan]="notrowspan" [colspan]="4">
          <div class="addNotification" style="width:100%">
            <a (click)="addNotification()" class="link">
              <i class="material-icons">add</i>{{translate.instant('DATA.ADD_NOTIFICATION')}}
            </a>
          </div>
        </mat-grid-tile>

        <mat-grid-tile *ngIf="!newFile.removeNotifications" [rowspan]="notrowspan" [colspan]="6">
          <mat-hint align="end">{{translate.instant('DATA.DEL_NOTIFICATION')}}</mat-hint>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="notrowspan" [colspan]="10">
          <mat-checkbox class="removeNotifications" [(ngModel)]="newFile.removeNotifications"
            (click)="removeAllNotifications()">
          </mat-checkbox>
          <span class="boxinfo">{{translate.instant('MASSEDIT.DEL_ALL_NOTIFICATIONS')}}</span>
        </mat-grid-tile>


      </mat-grid-list>
    </mat-expansion-panel>


    <mat-expansion-panel [disabled]="pShareDisabled">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Delen
        </mat-panel-title>
        <mat-panel-description>
          Delen met één of meerdere personen
          <img style="height:24px" src="../../assets/Nestas_toolbox_delen_narrow.png" />
        </mat-panel-description>

      </mat-expansion-panel-header>


      <mat-grid-list cols="10" rowHeight="35px" gutterSize="15px">
        <ng-container [formGroup]="form">
          <ng-container formArrayName="items" *ngFor="let n of sharedWith; let index=index ">

            <!--<mat-grid-tile [rowspan]="notrowspan" [colspan]="2">
            <label>{{translate.instant('DATA.SHARE')}} {{index+1}}:</label>
          </mat-grid-tile>-->

            <mat-grid-tile [rowspan]="notrowspan" [colspan]="10" [formGroupName]="index">
              <mat-form-field class="fill">
                <!--<input matInput class="full-width" [(ngModel)]="n.email" [ngModelOptions]="{standalone: true}" type="text"
                placeholder="{{translate.instant('DATA.EMAIL')}}" class="full-width margin-right-md">-->

                <input matInput type="text" [matAutocomplete]="contractorShareAutocomplete"
                  placeholder="{{translate.instant('DATA.EMAIL')}}" class="full-width margin-right-md"
                  formControlName="sharedWithEmail">

                <mat-autocomplete #contractorShareAutocomplete="matAutocomplete">
                  <mat-option *ngFor="let c of shareFilteredContractors[index] | async" [value]="formatContractor(c)">
                    {{formatContractor(c)}}
                  </mat-option>
                </mat-autocomplete>

              </mat-form-field>
            </mat-grid-tile>
          </ng-container>
        </ng-container>

        <mat-grid-tile *ngIf="!newFile.removeSharedWith" [rowspan]="notrowspan" [colspan]="10">
          <div class="addSharedWith" style="width:100%">
            <a (click)="addSharedWith()" class="link">
              <i class="material-icons">add</i>{{translate.instant('DATA.ADD_LINKTO')}}
            </a>
          </div>
        </mat-grid-tile>

        <!--<mat-grid-tile *ngIf="!newFile.removeSharedWith" [rowspan]="notrowspan" [colspan]="6">
        <mat-hint align="end">{{translate.instant('DATA.DEL_SHAREDWITH')}}</mat-hint>
      </mat-grid-tile>-->

        <mat-grid-tile [rowspan]="notrowspan" [colspan]="10">
          <mat-checkbox class="removeSharedWith" [(ngModel)]="newFile.removeSharedWith" (click)="removeAllSharedWith()">
          </mat-checkbox>
          <span class="boxinfo">{{translate.instant('MASSEDIT.STOP_ALL_SHARING')}}</span>
        </mat-grid-tile>
      </mat-grid-list>

    </mat-expansion-panel>

    <mat-expansion-panel [hideToggle]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-checkbox class="removeNotifications" [(ngModel)]="deleteSelected" (click)="deleteSelectedClick()">
            <span class="boxinfo">&nbsp; {{translate.instant('MASSEDIT.DELETE_SELECTION')}}</span>
          </mat-checkbox>

        </mat-panel-title>
        <mat-panel-description>
          &nbsp;
        </mat-panel-description>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </mat-accordion>


</div>

<div mat-dialog-actions>
  <button mat-stroked-button (click)="onNoClick()">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
  <button mat-raised-button cdkFocusInitial (click)="save()" color="primary">
    {{translate.instant('BUTTON.ACTION.SAVE')}}
  </button>
</div>